export class ReleaseFormsList {
    id: number;
    form_name: string;
    edit_access: boolean;
    active: boolean;
    clinic_no: number;

    constructor(id: number, form_name: string, edit_access: boolean, active: boolean, clinic_no: number) {
        this.id = id;
        this.form_name = form_name;
        this.edit_access = edit_access;
        this.active = active;
        this.clinic_no = clinic_no;
    }
}

export class ReleaseFormDetails {
    id: number;
    pet_det: boolean;
    procedures: string;
    prompt: string;
    form_name: string;
    actionType: string;
    role_access: string;
    active: boolean;
    clinic_no: number;
    temp_prompt?: string;

    constructor(id: number, pet_det: boolean, procedures: string, prompt: string, form_name: string, actionType: string, role_access: string, active: boolean, clinic_no: number, temp_prompt?: string) {
        this.id = id;
        this.pet_det = pet_det;
        this.procedures = procedures;
        this.prompt = prompt;
        this.form_name = form_name;
        this.actionType = actionType;
        this.role_access = role_access;
        this.active = active;
        this.clinic_no = clinic_no;
        this.temp_prompt = temp_prompt;
    }
}